import { CREATE_STORAGE_URL, DELETE_STORAGE_URL, LIST_STORAGE_URL, STORAGE_LIST_DROPDOWN, STORAGE_SINGLE_DETAIL } from "../api";
import axiosInstance from "../axiosInstance";

export const createStorageType = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_STORAGE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listStorageType = (props) => onResponse => {
    try {
        let BASE_URL = LIST_STORAGE_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props?.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const deleteStorage = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_STORAGE_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const getSingleStoreDetail = (props) => onResponse => {
    try {
        let BASE_URL = STORAGE_SINGLE_DETAIL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listStorageDropdown = (props) => onResponse => {
    try {
        let BASE_URL = STORAGE_LIST_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });



    } catch (error) {

    }
}
